import { ImportRequestScanResult, ImportRequestStatus } from 'services/import-requests/enums'
import { isUploadedImportRequestDetail } from 'services/import-requests/importRequestUtils'
import type { ImportRequestVerificationDetail } from 'services/import-requests/types'

export type ImportRequestFailureAlertType = 'rejected' | 'failed'

interface UseImportRequestFailureAlertParams {
  importRequest: ImportRequestVerificationDetail
}

export const useImportRequestFailureAlert = ({ importRequest }: UseImportRequestFailureAlertParams) => {
  if (importRequest.status === ImportRequestStatus.Rejected) {
    if (
      isUploadedImportRequestDetail(importRequest) &&
      importRequest.scanResult === ImportRequestScanResult.ThreatDetected
    ) {
      return {
        alertType: null,
        message: null
      }
    }

    return {
      alertType: 'rejected' as ImportRequestFailureAlertType,
      message: `The request was rejected with a note: "${importRequest.rejectionReason}"`
    }
  }

  if (importRequest.status === ImportRequestStatus.Failed) {
    return {
      alertType: 'failed' as ImportRequestFailureAlertType,
      message: importRequest.failureReason || 'Failed to import data'
    }
  }

  return {
    alertType: null,
    message: null
  }
}
